

import orderDetail from '../libs/mixins/orderDetail';
import saveLoginData from '../libs/utils/authUtils';

export default {
  name: 'HistoryView',
  components: {
  },
  mixins: [orderDetail],
  data: () => ({
    email: '',
    orders: [],
  }),
  computed: {
    mobile() {
      return this.$q.screen.lt.md;
    },
  },
  created() {
    const orders = this.$session.get('historyOrders');
    this.email = this.$session.get('email');
    if (orders) {
      this.orders = orders;
    }
  },
  methods: {
    async goToOrder(order) {
      this.loaderShow('Cargando orden');
      try {
        const contact = typeof order.emailContact === 'string' ? order.emailContact.trim() : '';
        const customer = typeof order.customerEmail === 'string' ? order.customerEmail.trim() : '';
        const effectiveEmail = contact !== '' ? contact : (customer || this.email || '');
        this.email = effectiveEmail;
        this.$session.set('superOrderId', order.superOrderIdDMS);
        this.$session.set('dealerId', order.dealerId);
        this.$session.set('orders', [order]);
        this.$session.set('emailContact', contact);
        this.$session.set('email', effectiveEmail);
        this.$session.set('orderIdDMS', order.orderIdDMS);

        const { showTutorial, showNoticePrivacy } = saveLoginData(
          this.$session,
          order,
          effectiveEmail,
        );

        this.showTutorial = showTutorial;
        this.showNoticePrivacy = showNoticePrivacy;
        await this.getOrderDetail();
      } finally {
        this.loaderHide();
      }
    },
  },
};
